module.exports = "/static/assets/f9d3526e16c680095b5cf8543ac3d96e.png";